export default "__VITE_ASSET__m53sCqn6__"